'use strict';

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var isObject = function isObject(value) {
  return _typeof(value) === 'object' && value !== null;
};

var mapObjectSkip = Symbol('skip'); // Customized for this use-case

var isObjectCustom = function isObjectCustom(value) {
  return isObject(value) && !(value instanceof RegExp) && !(value instanceof Error) && !(value instanceof Date);
};

var mapObject = function mapObject(object, mapper, options) {
  var isSeen = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : new WeakMap();
  options = _objectSpread({
    deep: false,
    target: {}
  }, options);

  if (isSeen.has(object)) {
    return isSeen.get(object);
  }

  isSeen.set(object, options.target);
  var _options = options,
      target = _options.target;
  delete options.target;

  var mapArray = function mapArray(array) {
    return array.map(function (element) {
      return isObjectCustom(element) ? mapObject(element, mapper, options, isSeen) : element;
    });
  };

  if (Array.isArray(object)) {
    return mapArray(object);
  }

  for (var _i2 = 0, _Object$entries = Object.entries(object); _i2 < _Object$entries.length; _i2++) {
    var _ref3 = _Object$entries[_i2];

    var _ref2 = _slicedToArray(_ref3, 2);

    var key = _ref2[0];
    var value = _ref2[1];
    var mapResult = mapper(key, value, object);

    if (mapResult === mapObjectSkip) {
      continue;
    }

    var _mapResult = _slicedToArray(mapResult, 3),
        newKey = _mapResult[0],
        newValue = _mapResult[1],
        _mapResult$ = _mapResult[2];

    _mapResult$ = _mapResult$ === void 0 ? {} : _mapResult$;
    var _mapResult$$shouldRec = _mapResult$.shouldRecurse,
        shouldRecurse = _mapResult$$shouldRec === void 0 ? true : _mapResult$$shouldRec; // Drop `__proto__` keys.

    if (newKey === '__proto__') {
      continue;
    }

    if (options.deep && shouldRecurse && isObjectCustom(newValue)) {
      newValue = Array.isArray(newValue) ? mapArray(newValue) : mapObject(newValue, mapper, options, isSeen);
    }

    target[newKey] = newValue;
  }

  return target;
};

module.exports = function (object, mapper, options) {
  if (!isObject(object)) {
    throw new TypeError("Expected an object, got `".concat(object, "` (").concat(_typeof(object), ")"));
  }

  return mapObject(object, mapper, options);
};

module.exports.mapObjectSkip = mapObjectSkip;